export default function () {
	return function (input) {
		if (input && (input.length == 11 || input.length == 13)) {
			return input.replace(/\D/g, '').replace(/(\d{8})(\d{1})(\d{2})/, '$1-$2-$3');
		}
	};
}
